import React from 'react';

export interface KeyMetricBadgeProps {
  label: string;
  value: string;
  /** Signed delta in percentage points; colors green/red by direction. */
  delta?: number | null;
  title?: string;
  /** Extra classes on the value span — e.g. a min-width to reserve space for a
   *  live-updating value so the header doesn't reflow as it changes. */
  valueClassName?: string;
}

/**
 * Chart-DS inline KPI badge: 9px muted label + 11px bold value (+ optional
 * signed delta), on a subtle rounded chip. Used in chart widget headers.
 */
const KeyMetricBadge: React.FC<KeyMetricBadgeProps> = ({ label, value, delta, title, valueClassName }) => (
  <div className="inline-flex items-center gap-1.5 rounded bg-neutral-100 px-2 py-1" title={title}>
    <span className="text-[9px] uppercase tracking-wide text-neutral-400">{label}</span>
    <span className={`text-[11px] font-bold text-neutral-900 ${valueClassName ?? ''}`}>{value}</span>
    {delta != null && (
      <span className={`text-[10px] font-semibold ${delta >= 0 ? 'text-success-600' : 'text-danger-600'}`}>
        {delta >= 0 ? '+' : ''}{delta.toFixed(1)}%
      </span>
    )}
  </div>
);

export default KeyMetricBadge;
